import CompanyMeta from "@/components/company-meta";
import { useCompanyById } from "@/hooks/company-by-id.hook";
import { useCurrentUserProfile } from "@/hooks/current-user-profile.hook";

const UserHeading = () => {
  const { data: userProfile } = useCurrentUserProfile();

  const { data: company, isLoading: companyIsLoading } = useCompanyById(
    userProfile?.companyId || "",
  );

  return (
    <div>
      <h1 className="mb-1 text-2xl font-semibold text-[#13171B]">
        ¡Hola, {userProfile?.name}!
      </h1>

      <CompanyMeta company={company} isLoading={companyIsLoading} />
    </div>
  );
};

export default UserHeading;
